(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Input", [], factory);
	else if(typeof exports === 'object')
		exports["Input"] = factory();
	else
		root["Input"] = factory();
})(this, function() {
return 